import createIcon from '../../createIcon';

/**
 * @component @name Wifi2Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAwMiA2LjVDMTUuMDMwMiA2LjUgMTcuNzgwMiA3LjczIDE5Ljc2MDIgOS43MkwxNy42NDAyIDExLjg0QzE2LjIwMDIgMTAuNCAxNC4yMDAyIDkuNSAxMi4wMDAyIDkuNUM5LjgwMDIzIDkuNSA3LjgwMDIzIDEwLjQgNi4zNjAyMyAxMS44NUw0LjI0MDIzIDkuNzNDNi4yMjAyMyA3LjczIDguOTcwMjMgNi41IDEyLjAwMDIgNi41Wk0xMi4wMDAyIDEyLjVDMTAuNjIwMiAxMi41IDkuMzcwMjMgMTMuMDYgOC40NzAyMyAxMy45NkwxMi4wMDAyIDE3LjVMMTUuNTMwMiAxMy45NkMxNC42MzAyIDEzLjA2IDEzLjM4MDIgMTIuNSAxMi4wMDAyIDEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wifi2Bar = createIcon('Wifi2Bar', [
  [
    'path',
    {
      d: 'M12.0002 6.5C15.0302 6.5 17.7802 7.73 19.7602 9.72L17.6402 11.84C16.2002 10.4 14.2002 9.5 12.0002 9.5C9.80023 9.5 7.80023 10.4 6.36023 11.85L4.24023 9.73C6.22023 7.73 8.97023 6.5 12.0002 6.5ZM12.0002 12.5C10.6202 12.5 9.37023 13.06 8.47023 13.96L12.0002 17.5L15.5302 13.96C14.6302 13.06 13.3802 12.5 12.0002 12.5Z',
      key: '8clrod',
    },
  ],
]);

export default Wifi2Bar;
